var map = {
	"./0.png": 961041,
	"./1.png": 450824,
	"./2.png": 787683,
	"./3.png": 539930,
	"./4.png": 363701,
	"./5.png": 905407,
	"./6.png": 30439,
	"./7.png": 277950,
	"./8.png": 823817,
	"./9.png": 429344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 852620;